import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import AddIcon from '@material-ui/icons/Add'
import PaidIcon from '@mui/icons-material/Paid';
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import { useContext } from "react"
import AuthContext from '../../../context/AuthProvider';
import {validarCurrency} from '../../../constants/moneda'
import './controlpagos.scss';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
const DETAIL_URL = '/treatments/'
const ControlPagos = (props) => {
  const contexto = useContext(AuthContext)
  const axiosPrivate = useAxiosPrivate();
    
  
  const columns = [
    { title: 'N°', render: (rowData) => rowData.tableData.id + 1, width: '4%' },
    { title: 'A/Cuenta', field: 'acuenta', type: 'numeric' },
    { title: 'Saldo', field: 'saldo', type: 'numeric' },
    { title: 'TOTAL', field: 'total', type: 'numeric' },
    { title: 'Fecha', field: 'fecha' },
  ];

  const [data, setData] = useState([
    // { fecha: '12-23-20', acuenta: 100, saldo: 50, total: 150 },
  ]);

  const [openDialog, setOpenDialog] = useState(false);
  const [newPago, setNewPago] = useState({
    total: props.total,
    acuenta: 0,
    saldo: 0,
    fecha: "",
    idT: props.idT
  });
  const initialState = {
    total: props.total,
    acuenta: 0,
    saldo: 0,
    fecha: props.fecha,
    idT: props.idT
  }

  const handleInputChange = (event) => {
    // console.log(props.total)
    const { name, value } = event.target;

    // Actualiza el valor de 'acuenta' y realiza el cálculo para 'saldo'
    if (name === 'acuenta') {
      const acuentaValue = parseFloat(value);
      setNewPago({
        ...newPago,
        [name]: acuentaValue,
        saldo: newPago.total - acuentaValue,
      });
    } else {
      // Si no es 'acuenta', simplemente actualiza el valor
      setNewPago({ ...newPago, [name]: value });
    }
  };


const handleInsert = async () => {
    console.log(newPago)
 
    await axiosPrivate.put(`${DETAIL_URL}${newPago.idT}?valor=${'pay'}`, newPago)
    .then(response=>{
      // console.log(response.data.payments)
 
      // setData([...data, response.data.payments]);
      setData(response.data.payments);
      setNewPago(initialState);

      // sumar acuenta y mostrar en textfield
      var sumaAcuenta = 0;
      var sumaSaldo = 0;
      var totalP = 0;
      response.data.payments.forEach(function(objeto) {
        sumaAcuenta += objeto.acuenta;
        sumaSaldo = objeto.saldo;
        totalP = objeto.total
      });
      props.actualizarAcuenta(sumaAcuenta, sumaSaldo, totalP);
      // if(sumaAcuenta >= totalP){

      // }

      // setPaciente(prevState=>({
      //   ...prevState,
      //   acuenta : sumaAcuenta
      // }));  

      setOpenDialog(false);
      
           // Llama a la función peticionGetT desde las props
          //  props.peticionGetT();
    }).catch(error=>{
      console.log(error);
      // alert("Error al insertar por favor intente de nuevo")
      // window.location.reload();
    })

 
  };
  const handleDelete = async (rowData) => {
    const paymentId = rowData.tableData.id; // Asegúrate de tener un identificador único para cada pago (ej. id)
    console.log(paymentId);
    console.log(newPago.idT);

    try {
        await axiosPrivate.delete(`${DETAIL_URL}${newPago.idT}?paymentId=${paymentId}`)
            .then((response) => {
              console.log(response.data.payments)
              setData(response.data.payments);
              
              var sumaAcuenta = 0;
              var sumaSaldo = 0;
              var totalP = 0;
              response.data.payments.forEach(function(objeto) {
                sumaAcuenta += objeto.acuenta;
                // sumaSaldo = objeto.total - objeto.acuenta;
                totalP = objeto.total
              });
              sumaSaldo = totalP - sumaAcuenta
              props.actualizarAcuenta(sumaAcuenta, sumaSaldo, totalP);
              
                // Puedes realizar otras acciones después de eliminar el pago
            });
    } catch (error) {
        console.error('Error al eliminar el pago:', error);
        // Puedes manejar el error aquí (mostrar un mensaje, recargar la página, etc.)
    }
};

  
const handleCancel = () => {
    setNewPago(initialState);
    setOpenDialog(false);
  };

 // useEffect para inicializar newPago cuando el componente se monta
useEffect(() => {

  setNewPago(initialState);
  console.log('USEEFFECC')
  setData(props.paypay)
}, [ props.paypay, props.idT]);

useEffect(()=>{
  console.log('ME EJECUTO EFFECT PAGOS')
  props.peticionGetT();
},[data])

const handlePrint = (rowData) => {
  const pdf = new jsPDF();

  // Cambiar la fuente a Arial
  pdf.setFont('helvetica');

  // Encabezado con margen inferior
  pdf.setFontSize(17);
  const marginTop = 10; // Ajusta este valor según sea necesario
  pdf.text('COMPROBANTE DE PAGO', 61, marginTop);

  // Datos del consultorio
  pdf.setFontSize(12);
  pdf.text(contexto.auth?.razonSocial ?? 'S/D', 130, 20);
  pdf.text(contexto.auth?.address ?? 'S/D', 130, 25);
  pdf.text(`Telefono: ${contexto.auth?.phone ?? 'S/D'}`, 130, 30);

  // Detalles del paciente
  pdf.text(`Paciente: ${props.nombrePaciente??'S/D'}`, 14, 20);
  pdf.text(`Concepto: ${props.concepto??'S/D'}`, 14, 25);
  pdf.text(`Fecha: ${rowData.fecha??'S/D'}`, 14, 30);

  // Tabla de ítems
  const columns = ['Descripción', 'P. Total', 'Deuda', 'Pagado' ];
  const items = [
    [props.concepto, rowData.total, rowData.saldo, rowData.acuenta],
  ];

  pdf.autoTable({
    startY: 35,
    head: [columns],
    body: items,
    headStyles: { fillColor: [41, 128, 185], textColor: 255 },
    bodyStyles: { textColor: 0 },
  });

  // Total
  pdf.setFontSize(14);
  const finalY = pdf.autoTable.previous.finalY; // Obtener la posición final de la tabla
  pdf.text(`Total: ${validarCurrency(contexto.auth.phone)} ${rowData.acuenta??'S/D'}`, 170, finalY + 10);

  // Mensaje de agradecimiento centrado y más pequeño
  const mensajeAgradecimiento = '¡GRACIAS POR SU VISITA!';
  const mensajeFontSize = 10; // Ajusta el tamaño según sea necesario
  pdf.setFontSize(mensajeFontSize);

  const mensajeWidth = pdf.getStringUnitWidth(mensajeAgradecimiento) * mensajeFontSize;
  const mensajeX = (pdf.internal.pageSize.width - mensajeWidth) / 1.1;
  const mensajeY = finalY + 20;

  pdf.text(mensajeAgradecimiento, mensajeX, mensajeY);

  // Abrir la interfaz de impresión
  pdf.autoPrint();

  // Guardar o mostrar el PDF
  // pdf.save('recibo_pago.pdf'); // Descomentar para guardar el PDF
  pdf.output('dataurlnewwindow'); // Comentar si no deseas mostrar el PDF en una nueva ventana
};







  return (
    <Accordion className='payments'>
      <AccordionSummary  expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <PaidIcon />
        <h3 style={{ margin: '0', marginLeft: '8px' }}>Historial de Pagos</h3>
      </div>
      </AccordionSummary>

      <AccordionDetails className="controlpagos">
      <div className="addPaymentButtonContainer">
          <Button
            className="addPaymentButton"
            variant="contained"
            color="primary"
            onClick={() => {
              // props.peticionGetT()
              setNewPago(initialState);
              setOpenDialog(true) 
              
            }}
            startIcon={<AddIcon /> }
          >
           nuevo pago
          </Button>
        </div>
        <div >
          <MaterialTable
            columns={columns}
            data={data}
            title="Pagos Realizados"
            actions={[
              {
                icon: 'print',
                tooltip: "Imprimir",
                iconProps: { style: {color: "#111B21" } },
                onClick: (event, rowData) =>{
                  handlePrint(rowData)
         
                }
              },
              {
                icon: "delete",
                iconProps: { style: { color: "#F24E4F"} },
                tooltip: "Eliminar Registro",
                onClick: (event, rowData) => handleDelete(rowData),
                // onClick: (event, rowData) =>
                //   seleccionarArtista(rowData, "Eliminar"),
              },

            ]}
            options={{
              exportButton: true,
              actionsColumnIndex: -1,
              headerStyle: {
                backgroundColor: '#3F51B5',
                color: '#FFFFFF',
                tableLayout: 'fixed', // Añade esta línea
              },
              rowStyle: {
                backgroundColor: '#EEE',
                fontSize: '16px',
                overflowWrap: 'break-word',
              },
            }}
            localization={{
              header: {
                actions: 'Acciones',
              },
              body: {
                emptyDataSourceMessage: 'No hay registros ',
              },
            }}
          />
        </div>

      </AccordionDetails>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="xs">
        <DialogTitle>Nuevo Pago</DialogTitle>
        <DialogContent>
        <TextField
            label="Total"
            type="number"
            name="total"
            value={newPago.total}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
                  <TextField
            label="A/Cuenta"
            type="number"
            name="acuenta"
            value={newPago.acuenta}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Saldo"
            type="number"
            name="saldo"
            value={newPago.saldo}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            style={{ display: 'none' }}
          />
          <TextField
            label="Fecha"
            type="date"
            name="fecha"
            value={newPago.fecha}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />



          <Button color="primary" onClick={handleInsert}>
            Insertar
          </Button>
          <Button color="secondary" onClick={handleCancel}>
            Cancelar
          </Button>
        </DialogContent>
      </Dialog>
    </Accordion>
  );
};

export default ControlPagos;
